import { useQuery } from '@tanstack/react-query';

import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';

import { SEARCH_QUERY_KEYS } from '../constants';
import { loadProductsCustomQuery } from './DataLoading/LoadProductsCustomQuery';

type Params = {
    queryKey?: string;
};

export const useLoadProductsCustomQuery = ({ queryKey }: Params) => {
    const {
        data,
        isFetching: isResultsLoading,
        error,
    } = useQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_PRODUCTS_CUSTOM_QUERY, queryKey],
        queryFn: async ({ signal }) => {
            return loadProductsCustomQuery({ queryKey, signal });
        },
        enabled: !!queryKey,
    });
    useLogError(error, DDComponent.Search);

    return { isLoading: isResultsLoading, error, data };
};
